/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { SubjektResponse } from '../types/Subjekt';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type SubjektyRetrieveRequest = {} | null | undefined;
export type SubjektyRetrieveResponse = SubjektResponse;

export type SubjektyRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this subjekt.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/subjekty/{id}/
 *
 * ```yaml
 * operationId: subjekty_retrieve
 * description: Seznam subjektů je synchronizován každý den v cca 01:00
 * tags:
 *   - subjekty
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/Subjekt'
 *     description: ''
 * ```
 */
export const subjektyRetrieveOperation = ({ id, ...rest }: SubjektyRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/subjekty/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/subjekty/{id}/' };
  };

/**
 * GET /dmx-server/subjekty/{id}/
 *
 * ```yaml
 * operationId: subjekty_retrieve
 * description: Seznam subjektů je synchronizován každý den v cca 01:00
 * tags:
 *   - subjekty
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/Subjekt'
 *     description: ''
 * ```
 */
export const subjektyRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: SubjektyRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<SubjektResponse>> => {
  const operation = subjektyRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/subjekty/{id}/
 */
export const useSubjektyRetrieveResource = (
  query: SubjektyRetrieveQuery | null,
  useCached?: boolean,
): UseResource<SubjektyRetrieveResponse> => {
  return useResource<SubjektyRetrieveResponse>({
    path: query === null ? null : subjektyRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
